import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { connect, useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import head from "lodash/head";
import { createStructuredSelector } from "reselect";
import validate from "validations";
import { forms, publicPaths, AUTH_MODES, CALL_BACK_URL } from "utils/constants";
import SmartRender from "containers/SmartRender";
import { userLoginAction, userLoginOTP, setData } from "ducks/actions";
import { getDeviceId } from "utils/localStorage";
import { makeSelectLoginEmail } from "ducks/selectors/forms/loginForm";
import { gotoUrl, getChannelFromUrl, getURLParams } from "utils/helpers";
import {
  makeSelectPageValidations,
  makeSelectThemeColors,
  makeSelectLoginFormMessageData,
  makeSelectSocialLoginEmails,
  makeSelectOnFailureRedirectUrlSelector,
  makeSelectIsFetchingData,
  makeSelectAULostServiceParams,
  makeSelectUserConfirmLostService
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
const EmailSelection = Component =>
  function Comp(props) {
    const { emailList, isFetchingData, change, userConfirmLostService } = props;
    const dispatch = useDispatch();
    const { failure_url: onFailureRedirectUrl } = getURLParams();
    const haveSingleEmail = emailList && emailList.length === 1;
    const selectedEmail = useSelector(makeSelectLoginEmail());
    const VerifyOTPPath = publicPaths.VERIFY_OTP.replace(
      ":channel",
      getChannelFromUrl()
    );
    const auLostServiceData = useSelector(makeSelectAULostServiceParams());

    useEffect(() => {
      if (haveSingleEmail && userConfirmLostService) {
        const email = get(head(emailList), "value");
        change("email", email);
        callOtpSigningFlow(email);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [haveSingleEmail, userConfirmLostService]);

    /**
     * Dispatches the OTP for email request.
     * Upon successful response this will redirect user to OTP page
     * @param {string} email user provided email
     */
    const requestOTPForEmail = email => {
      const additionalHeaders = {};
      const bodyParams = {
        email,
        auth_mode: AUTH_MODES.ENHANCED_EMAIL_OTP
      };
      /**
       * redirect user to OTP page if successful
       * @param {object} response success response result
       * @param {object} errors API errors only if failed
       */
      const onSubmitCallback = (response, errors) => {
        const success = !errors;
        if (success) {
          const queryParams = { key: Date.now(), isSocialLogin: true };
          gotoUrl(VerifyOTPPath, false, queryParams);
        } else {
          console.error("Request OTP failed. Cause: ", errors);
        }
      };
      dispatch(userLoginOTP(additionalHeaders, bodyParams, onSubmitCallback));
    };
    /**
     * Dispatches the User Login action event.
     * Upon response this will dispatch the OTP request
     */
    const onClickContinueButton = () => {
      callOtpSigningFlow(selectedEmail);
    };

    const callOtpSigningFlow = email => {
      const deviceId = getDeviceId();
      const headers = {};
      const bodyParams = {
        email: email,
        device_id: deviceId
      };
      const onSuccess = (_, errors) => {
        if (!errors) {
          requestOTPForEmail(email);
        } else if (haveSingleEmail) {
          gotoUrl(onFailureRedirectUrl);
        }
      };
      dispatch(userLoginAction(headers, bodyParams, onSuccess));
    };
    /**
     * Dispatches the User Login action event.
     * When click confirm button in  confirm modal view
     */
    const confirmLostService = () => {
      const params = { targeturl: CALL_BACK_URL.AU_LOST_SERVICE };
      gotoUrl(auLostServiceData.url, false, {}, false, params);
      dispatch(
        setData({
          key: "userLostServiceData",
          data: { userConfirmLostService: true }
        })
      );
    };

    return isFetchingData ? (
      <Spinner size={200} sx={styles.fullPage} />
    ) : (
      <Component
        {...props}
        onSubmit={onClickContinueButton}
        onClickConfirmLostService={confirmLostService}
        nobox
      />
    );
  };
const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.USER_LOGIN_FORM),
  emailList: makeSelectSocialLoginEmails(),
  failureUrl: makeSelectOnFailureRedirectUrlSelector(),
  loginEmail: makeSelectLoginEmail(),
  themeColors: makeSelectThemeColors(),
  messageData: makeSelectLoginFormMessageData(),
  isFetchingData: makeSelectIsFetchingData(["userLoginOTP", "userLogin"]),
  userConfirmLostService: makeSelectUserConfirmLostService()
});
const withConnect = connect(mapStateToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.USER_LOGIN_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(EmailSelection(SmartRender));
